import React from 'react';

import { useRecuperarDicasMaisQuery } from 'View/Service/Default/DicasMais';

interface Props {
  unidadeDeAprendizagemId: number;
}

const DicasMais = ({ unidadeDeAprendizagemId }: Props): React.ReactElement => {
  const { data: { dicas_mais } = {} } = useRecuperarDicasMaisQuery({
    options: { unidade_de_aprendizagem_id: unidadeDeAprendizagemId },
  });

  return (
    <React.Fragment>
      <p className="fs-2 fw-bold">Dicas+</p>
      <p>
        Expanda ainda mais seu conhecimento no assunto com essas dicas incríveis que o
        professor te deu!
      </p>
      {dicas_mais?.map((dica, chave) => (
        <p
          key={`${dica.id}-${dica.modificado}`}
          className={`fs-5 pt-3 cursor-pointer ${chave ? 'border-top' : ''} ${
            dica.url ? 'text-primary' : ''
          }`}
          onClick={() => (dica.url ? window.open(dica.url) : null)}
        >
          {dica.titulo}
          <small className="text-muted d-block fs-6">
            Atualizado em {dica.modificado.data().toLocaleString()}
          </small>
        </p>
      ))}
    </React.Fragment>
  );
};

export default DicasMais;
